/* unplugin-vue-components disabled */import { render } from "./pro-list.vue?vue&type=template&id=1e7dec8e&scoped=true"
import script from "./pro-list.vue?vue&type=script&lang=js"
export * from "./pro-list.vue?vue&type=script&lang=js"

import "./pro-list.vue?vue&type=style&index=0&id=1e7dec8e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7dec8e"]])

export default __exports__